var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndustria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.8 24.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65,19.39h2.07V9.92h-2.07v9.47Zm5.72,0h2.07V5.41h-2.07v13.98Zm5.72,0h2.07v-5.1h-2.07v5.1ZM2.07,24.8c-.55,0-1.03-.21-1.45-.62-.41-.41-.62-.9-.62-1.45V2.07C0,1.52,.21,1.03,.62,.62c.41-.41,.9-.62,1.45-.62H22.73c.55,0,1.03,.21,1.45,.62,.41,.41,.62,.9,.62,1.45V22.73c0,.55-.21,1.03-.62,1.45-.41,.41-.9,.62-1.45,.62H2.07Zm0-2.07H22.73V2.07H2.07V22.73ZM2.07,2.07v0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustria);
export default __webpack_public_path__ + "static/media/industria.019d3211717c821b0795f80eea6db0b2.svg";
export { ForwardRef as ReactComponent };